import { 
  MenuItem, 
  Box, 
  TextField, 
  Button, 
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton, 
} from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";
import { useFetchData } from "../../../components/hooks/useFetchData";
import { Visibility } from "@mui/icons-material";

const vfsdata = {
  candidatevfsuuid: "",
  slotdate: "", // Replaced interviewdate with slotdate
  journeydate: "", // Added journeydate
  status: "VFS Booked", // Default to 'Scheduled'
};

export const VFSSchedule = ({ isLoading, lead, getCandidateLifecyclEevents }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { fetchData } = useFetchData();
  const [vfslist, setVFSList] = useState([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      candidateid: lead?.id || "",
      candidatevfsuuid: vfsdata.candidatevfsuuid,
      slotdate: vfsdata?.slotdate
        ? dayjs(vfsdata.slotdate)
        : null,
      journeydate: vfsdata?.journeydate
        ? dayjs(vfsdata.journeydate)
        : null, 
        recieveddate: vfsdata?.recieveddate
        ? dayjs(vfsdata.recieveddate)
        : null, 
      status: vfsdata.status || "", 
    },
  });

  const statusList = [
    { id: "VFS Booked", label: "VFS Booked" },
    { id: "VFS Rejected", label: "VFS Rejected" },
    { id: "VFS Recieved", label: "VFS Recieved" },
  ];

  const onSubmit = async (data) => {

      const formattedSlotDate = data.slotdate ? dayjs(data.slotdate).format("YYYY-MM-DD") : null;
      const formattedJourneyDate = data.journeydate ? dayjs(data.journeydate).format("YYYY-MM-DD") : null;
      const formattedRecievedDate = data.recieveddate ? dayjs(data.recieveddate).format("YYYY-MM-DD") : null;

      const body = {
        ...data,
        slotdate: formattedSlotDate,
        journeydate: formattedJourneyDate, 
        recieveddate: formattedRecievedDate, 
      };
      const result = await fetchData("managecandidatevfs", {
        method: "post",
        body: body,
      });
      if (result?.code === 200) {
        // Reset the form after successful submission
        reset({
          candidateid: lead?.id || "",
          candidatevfsuuid: "",
          slotdate: null,
          journeydate: null, // Reset journeydate
          recieveddate: null,
          status: "VFS Booked", // Reset to default 'Booked'
        });
        getAllVFS();
        getCandidateLifecyclEevents();
        enqueueSnackbar(result.message || "Successful!", {
          variant: "success",
        });
      } else {
        enqueueSnackbar(result.message || "Something went wrong!", {
          variant: "error",
        });
      }
    // }
  };

  const getAllVFS = async () => {
    const body = {
      candidateid: lead?.id,
    };
    const result = await fetchData("getcandidatevfs", {
      method: "post",
      body: body,
    });
    if (result?.code === 200) {
      setVFSList(result.data);
    }
  };

  const editVFS = async (data) => {
    const formattedSlotDate = dayjs(data.slotdate, "YYYY-MM-DD");
    const formattedJourneyDate = dayjs(data.journeydate, "YYYY-MM-DD");
    const formattedRecievedDate = dayjs(data.recieveddate, "YYYY-MM-DD");
    reset({
      candidateid: lead?.id || "",
      candidatevfsuuid: data.candidatevfsuuid,
      slotdate: formattedSlotDate.isValid() ? formattedSlotDate : null,
      journeydate: formattedJourneyDate.isValid() ? formattedJourneyDate : null,
      recieveddate: formattedRecievedDate.isValid() ? formattedRecievedDate : null,
      status: data.status,
    });
  };

  React.useEffect(() => {
    const fetchDataAsync = async () => {
      await getAllVFS();
    };
    fetchDataAsync();
  }, []);

  const inputStyle = {
    "& .MuiInputBase-input": { m: 0, p: "4px 8px", width: 366 },
    "& .MuiOutlinedInput-root": { borderRadius: "12px", height: 44 },
    my: 1,
    width: "40%",
  };

  return (
    <Box px={2} sx={{
      overflowY: 'scroll',
      paddingBottom: '11px',
      scrollbarWidth: 'none', // For Firefox
    '&::-webkit-scrollbar': {
      display: 'none', // For Chrome, Safari, and Edge
    },
    }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Typography variant="h6">Schedule VFS</Typography>

        <div className="inst-scroll-wrapper">

          {/* VFS Status */}
          <TextField
            select
            variant="outlined"
            {...register("status", { required: "Status is required" })}
            error={!!errors.status}
            value={watch("status")}
            helperText={errors.status?.message}
            sx={inputStyle}
          >
            {statusList.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <span style={{ marginLeft: "12px" }}></span>
          
          {/* Slot Date */}
          <Controller
            name="slotdate"
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                format="LL"
                label="Slot date"
                sx={inputStyle}
              />
            )}
          />
          <span style={{ marginLeft: "12px" }}></span>

          {/* Journey Date */}
          <Controller
            name="journeydate"
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                format="LL"
                label="Journey date"
                sx={inputStyle}
              />
            )}
          />
          <span style={{ marginLeft: "12px" }}></span>
          
          {/* Recieved Date */}
          <Controller
            name="recieveddate"
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                format="LL"
                label="Recieved date"
                sx={inputStyle}
              />
            )}
          />
          <span style={{ marginLeft: "12px" }}></span>
          
        </div>

        <Button
          variant="contained"
          type="submit"
          className="ly-submit-btn"
          sx={{ marginTop: 2 }}
        >
          Submit
        </Button>

        {/* Table for Interviews */}
        <TableContainer sx={{ mt: 2, maxHeight: 300, overflowY: "auto" }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow
                sx={{
                  bgcolor: "#3A80F7",
                }}
              >
                <TableCell sx={{ color: "white", borderTopLeftRadius: 8 }}>
                  Slot Date
                </TableCell>
                <TableCell sx={{ color: "white" }}>
                  Journey Date
                </TableCell>
                <TableCell sx={{ color: "white"}}>
                  Recieved Date
                </TableCell>
                <TableCell sx={{ color: "white" }}>Status</TableCell>
                <TableCell sx={{ color: "white", borderTopRightRadius: 8 }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vfslist.length > 0 ? (
                vfslist.map((li) => (
                  <TableRow key={li.id}>
                    <TableCell>
                      {li?.slotdate ? dayjs(li.slotdate).format("LL") : ""}
                    </TableCell>
                    <TableCell>
                      {li?.journeydate ? dayjs(li.journeydate).format("LL") : ""}
                    </TableCell>
                    <TableCell>
                      {li?.recieveddate ? dayjs(li.recieveddate).format("LL") : ""}
                    </TableCell>
                    <TableCell>{li.status}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => editVFS(li)}>
                        <Visibility />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No VFS found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </form>
    </Box>
  );
};
